require('./index.less');

var locale = require('./i18n');
var tpl = require('./index.html');
var hash = require('./hash');

var loginPage = {
    init: function() {
        var settings = window.loginPageSettings;
        if (settings.backgroundImgUrl) {
            $('body').css({
                backgroundImage: 'url("' + settings.backgroundImgUrl
                                + '?t=' + new Date().getTime() + '")',
                backgroundSize: '100% 100%'
            });
        }

        $('body').html(tpl({
            projectTitle: window.projectTitle,
            locale: locale()
        }));



        $('#login').animate({
            top: '50%'
        }, 600, 'easeOutBounce');
            
        // set login
        $('#login-btn').button()
            .click(function() {
                $('#tips').html('').removeClass('ui-state-error');
                var uid = $('#uid').val(), pwd = $('#pwd').val();
                if (!uid || !pwd) {
                    $('#tips').addClass('ui-state-error')
                        .html(locale('nullTips'));
                    return;
                }
                pwd = hash.digest(window.hashType, pwd);

                var loginURL = window.location.pathname.replace(/\/$/, '');
                $.ajax({
                    url:  loginURL + '/' + uid + '/' + pwd,
                    dataType: 'json',
                    type: 'post',
                    success: function(result) {
                        if (!result.success) {
                           $('#tips').addClass('ui-state-error')
                            .html(locale('loginWrong'));
                        } else {
                           window.location.href = window.homePageURL;
                        }
                    },
                    error: function(e) {
                        alert(e.responseText);
                    }
                });
        });
        $(window).keyup(function(e) {
            if (e.keyCode === 13) {
                $('#login-btn').focus().click();
            }
        });
    }
};

$(function() {
    loginPage.init();
});


//////////////////
// WEBPACK FOOTER
// ./src/pages/login/index.js
// module id = 0
// module chunks = 0